<template>
	<v-card class="elevation-0" >
		<v-row>
			<v-col cols="12">
				<v-card class="shadowCard" >
		      <v-card-title>
		        Datos del alumno
		      </v-card-title>
		      <v-card-text>
			  	<!-- BUSCAR POR MATRICULA -->
			  	<label class="pl-0 black--text">Alumno</label>
			  	<div class="text-caption grey--text">Escribe al menos 3 letras o la matrícula para buscar; no se cargan todos los alumnos.</div>
					<v-row>
						<v-col cols="12" class="pt-0">
							<v-tooltip bottom color="blue" max-width="300">
								<template v-slot:activator="{ on, attrs }">
									<v-autocomplete
					          filled 
					          dense
					          clearable
					          no-filter
					          v-model="alumnoSeleccionado"
					          :items="itemsAlumnosAutocomplete"
					          :loading="loadingAlumnos"
					          :search-input.sync="alumnoSearchInput"
					          label="Buscar alumno"
					          hide-details
					          return-object
					          item-text="datos_completos"
					          item-value="id_alumno"
					          class="mt-4"
					          placeholder="Ej. nombre o matrícula"
					          v-bind="attrs"
					          v-on="on"
					        >
					        </v-autocomplete>
								</template>
								<span>Busca y selecciona el alumno que deseas reinscribir</span>
							</v-tooltip>
						</v-col>
					</v-row>

						<v-divider class="my-4"></v-divider>

			    <!-- Datos generales del alumno -->
			    <label class="pl-0 black--text" >Datos generales</label>
					<v-row v-if="alumnoSeleccionado">
						<v-col cols="12" sm="6">
							<v-tooltip bottom color="blue" max-width="300">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
									  filled 
									  dense
									  readonly
									  hide-details
									  :value="alumnoSeleccionado.nombre"
									  label="Nombre"
									  v-bind="attrs"
									  v-on="on"
									></v-text-field>
								</template>
								<span>Nombre del alumno seleccionado</span>
							</v-tooltip>
						</v-col>

						<v-col cols="12" sm="6">
							<v-tooltip bottom color="blue" max-width="300">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
									  filled 
									  dense
									  readonly
									  hide-details
									  v-model="alumno.apellido_paterno"
									  label="Ap. Paterno"
									  v-bind="attrs"
									  v-on="on"
									></v-text-field>
								</template>
								<span>Apellido paterno del alumno seleccionado</span>
							</v-tooltip>
						</v-col>

						<v-col cols="12" sm="6">
							<v-tooltip bottom color="blue" max-width="300">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
									  filled 
									  dense
									  readonly
									  hide-details
									  v-model="alumno.apellido_materno"
									  label="Ap. Materno"
									  v-bind="attrs"
									  v-on="on"
									></v-text-field>
								</template>
								<span>Apellido materno del alumno seleccionado</span>
							</v-tooltip>
						</v-col>

						<v-col cols="12" sm="6">
							<v-tooltip bottom color="blue" max-width="300">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
									  filled 
									  dense
									  readonly
									  hide-details
									  v-model="alumno.edad"
									  label="Edad"
									  type="number"
									  v-bind="attrs"
									  v-on="on"
									></v-text-field>
								</template>
								<span>Edad del alumno seleccionado</span>
							</v-tooltip>
						</v-col>
					</v-row>

					<!-- Datos del contacto -->
					<v-divider class="my-4"></v-divider>
					<label class="pl-0 black--text" >Datos de contacto</label>
					<v-row v-if="alumnoSeleccionado">
						<v-col cols="12" sm="6">
							<v-tooltip bottom color="blue" max-width="300">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
									  filled 
									  dense
									  readonly
									  hide-details
									  v-model="alumno.telefono"
									  label="Teléfono"
									  type="number"
									  v-bind="attrs"
									  v-on="on"
									></v-text-field>
								</template>
								<span>Teléfono registrado del alumno</span>
							</v-tooltip>
						</v-col>

						<v-col cols="12" sm="6">
							<v-tooltip bottom color="blue" max-width="300">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
									  filled 
									  dense
									  readonly
									  hide-details
									  v-model="alumno.celular"
									  label="Celular"
									  type="number"
									  v-bind="attrs"
									  v-on="on"
									></v-text-field>
								</template>
								<span>Celular registrado del alumno</span>
							</v-tooltip>
						</v-col>
					</v-row>
		      </v-card-text>
		    </v-card>
			</v-col>
		</v-row>

		<v-card-actions>
      <v-tooltip bottom color="blue" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn 
          	text 
          	@click="dialogAddAlumno.estatus = false"
          	v-bind="attrs"
          	v-on="on"
          >
            Cancelar
          </v-btn>
        </template>
        <span>Cerrar y cancelar el proceso de reinscripción</span>
      </v-tooltip>

      <!-- <v-btn 
      	text 
        @click="steppers.paso = 1"
      >
        Regresar
      </v-btn> -->

      <v-spacer></v-spacer>
      <v-tooltip bottom color="blue" max-width="300" v-if="alumnoSeleccionado">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
          	tile
            color="primary"
            @click="steppers.paso = 2"
            v-bind="attrs"
            v-on="on"
          >
            Siguiente
          	<v-icon right small>mdi-arrow-right</v-icon>
          </v-btn>
        </template>
        <span>Continuar al siguiente paso para seleccionar grupo</span>
      </v-tooltip>
  	</v-card-actions>


  	<!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

    <AgregarProspecto     v-if="existeProspecto"             :parametrosProspectos="parametrosProspectos" @saveProspecto="saveProspecto"/>


	</v-card>
</template>
<script>
import axios from 'axios';
	import { mapGetters, mapActions } from 'vuex'
  import Alerta          from '@/components/alertas/Alerta.vue'
  import carga           from '@/components/alertas/carga.vue';

  import AgregarProspecto   from '@/components/inscripciones/AgregarProspecto.vue';


  import validarErrores  from '@/mixins/validarErrores'

	// Componentes
  export default {
  	components:{
      Alerta,
      carga,
      AgregarProspecto
    },

    mixins: [ validarErrores ],

  	props:[
			'grupo',
			'alumno',
			'steppers',
			'hermanos',
			'tutor',
			'dialogAddAlumno',
	  ],

    data: () => ({
    	escuela: 2,
			// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      cantidadHermanos: 1,

      respuestaAlerta:false,
      cargar: false,

			step:1,
			isTutor:true,

			opcion:1,

			posicionHermano: 0,

			empleados:[],
			sonHermanos:false,
			existeMatricula: false,
    	prospectos:[],
    	parametrosProspectos:{
    		estatus: false
    	},
    	existeProspecto:false,
    	prospecto: null,
    	alumnoSeleccionado: null,
    	alumnosBusqueda: [],
    	alumnoElegido: null,
    	alumnoSearchInput: '',
    	loadingAlumnos: false,
    	_debounceAlumnos: null,

    	alertaSeguridad: false,

    	headers:[
    		{ text: 'Nombre'       , value: 'nombre'       },
        { text: 'Telefono'     , value: 'telefono'     },
        { text: 'Grupo'        , value: 'grupo'        },
        { text: 'ID prospecto' , value: 'id_prospecto' },
    	]



    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP', 'getEscuela']),

    	escuelaBusqueda () {
    		return [334, 1].includes(this.getdatosUsuarioERPERP.iderp) ? 3 : this.getEscuela
    	},

    	itemsAlumnosAutocomplete () {
    		const list = [...this.alumnosBusqueda]
    		if (
    			this.alumnoElegido &&
    			!list.some(a => a.id_alumno === this.alumnoElegido.id_alumno)
    		) {
    			list.unshift(this.alumnoElegido)
    		}
    		return list
    	},
    },

    watch:{
    	alumnoSeleccionado( value){
    		if( value ){
    			this.alumnoElegido = { ...value }
    			this.alumno.nombre           = value.alumno
    			this.alumno.telefono         = value.telefono
    			this.alumno.celular          = value.celular || value.telefono
    			this.alumno.email            = value.email || ''
    			this.alumno.twilio_asignado  = value.twilio_asignado || ''
    			this.alumno.apellido_materno = value.apellido_materno
    			this.alumno.apellido_paterno = value.apellido_paterno
    			this.alumno.edad             = value.edad
    			this.alumno.id_alumno        = value.id_alumno
    			this.alumno.matricula        = value.matricula
    			this.alumno.unidad_negocio   = value.unidad_negocio
    		}else{
    			this.alumnoElegido = null
    			this.alumno.nombre           = ''
    			this.alumno.telefono         = ''
    			this.alumno.celular          = ''
    			this.alumno.apellido_materno = ''
    			this.alumno.apellido_paterno = ''
    			this.alumno.edad             = ''
    			this.alumno.id_alumno        = ''
    			this.alumno.matricula        = ''
    		}
    	},

    	alumnoSearchInput (val) {
    		if (this._debounceAlumnos) clearTimeout(this._debounceAlumnos)
    		this._debounceAlumnos = setTimeout(() => {
    			this.buscarAlumnosRemoto(val)
    		}, 400)
    	},
    },

    beforeDestroy () {
    	if (this._debounceAlumnos) clearTimeout(this._debounceAlumnos)
    },

    created () {
    	this.escuela = this.getEscuela
    	this.alumno.unidad_negocio = this.getEscuela
    },

    methods: {
    	debeBuscarAlumnos (q) {
    		const t = (q || '').trim()
    		if (!t) return false
    		if (/^\d+$/.test(t)) return t.length >= 1
    		return t.length >= 3
    	},

    	buscarAlumnosRemoto (q) {
    		const termino = (q || '').trim()
    		if (!this.debeBuscarAlumnos(termino)) {
    			this.alumnosBusqueda = []
    			this.loadingAlumnos = false
    			return
    		}

    		this.loadingAlumnos = true
    		const params = {
    			buscar: termino,
    			limit: 50,
    			escuela: this.escuelaBusqueda,
    		}

    		return this.$http.get('inscripciones.alumnos.busqueda', { params }).then(response => {
    			this.alumnosBusqueda = Array.isArray(response.data) ? response.data : []
    		}).catch(error => {
    			this.validarError(
    				error.response && error.response.data
    					? error.response.data.message
    					: 'Error al buscar alumnos'
    			)
    			this.alumnosBusqueda = []
    		}).finally(() => {
    			this.loadingAlumnos = false
    		})
    	},

      abrirDialogProspecto( ){
      	this.existeProspecto              = true
      	this.parametrosProspectos.estatus = true
      },

      saveProspecto( value ){
        this.alumno.nombre                   = value.nombre_completo
	    	this.alumno.apellido_paterno         = ''
	    	this.alumno.apellido_materno         = ''
	    	this.alumno.telefono                 = value.telefono
	    	this.alumno.celular                  = value.telefono
	    	this.alumno.id_tipo_alumno           = 1
	    	this.alumno.id_usuario_ultimo_cambio = this.getdatosUsuarioERPERP.iderp
	    	this.alumno.unidad_negocio           = this.getEscuela
	    	this.alumno.id_prospecto             = value.idprospectos
	    	this.existeMatricula                 = true
      },

    },
  }
</script>
